import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { loadLang } from '/@/lang'
import { registerIcons, changeFavicon } from '/@/utils/common'
import ElementPlus from 'element-plus'
import mitt from 'mitt'
import pinia from '/@/stores/index'
import { directives } from '/@/utils/directives'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import 'font-awesome/css/font-awesome.min.css'
import '/@/styles/index.scss'
import '/@/styles/web/index.scss'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { useSiteConfig } from '/@/stores/siteConfig'
import { initialize } from './api/frontend/index.js'
import { useRoute } from 'vue-router'
// modules import mark, Please do not remove.

async function start() {
    const app = createApp(App)
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }
    app.use(pinia)

    // 全局语言包加载
    await loadLang(app)

    app.use(router)
    app.use(ElementPlus)
    app.use(Antd)

    // 全局注册
    directives(app) // 指令
    registerIcons(app) // icons
    const route = useRoute()

    const siteConfig = useSiteConfig()
    // console.log(siteConfig);
    initialize(res => {
        console.log(res);

        try {
            // console.log(siteConfig.$state.siteName);
            if (siteConfig.$state.siteName == '品茗AI技术标' || route?.query?.memberId) {
                // console.log('品茗AI技术222标');
                changeFavicon('/favicon_pinming.ico')
            } else if (siteConfig.$state.siteName == '云策智能科技') {

                changeFavicon('/favicon_yunce.ico')
            }
        } catch (error) {
            console.log(error);
        }
    })

    app.mount('#app')


    // modules start mark, Please do not remove.

    app.config.globalProperties.eventBus = mitt()
}
start()
